<template>
  <footer>Hielera Los Hermanos, &copy;{{ year }}</footer>
</template>

<script>
export default {
  name: 'AppFooter',
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>
